import { enableProdMode } from '@angular/core';

import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {platformBrowser} from "@angular/platform-browser";

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentryDSN,
  integrations: [
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: "system",
      showBranding: false,
      triggerLabel: "Feedback",
      triggerAriaLabel: "Feedback",
      formTitle: "Feedback geven",
      submitButtonLabel: "Verzenden",
      cancelButtonLabel: "Annuleer",
      confirmButtonLabel: "Bevestig",
      addScreenshotButtonLabel: "Screenshot toevoegen",
      removeScreenshotButtonLabel: "Screenshot verwijderen",
      nameLabel: "Naam",
      namePlaceholder: "Naam",
      emailLabel: "Email",
      emailPlaceholder: "Email",
      isRequiredLabel: "(verplicht)",
      messageLabel: "Bericht",
      messagePlaceholder: "Wat ging er fout?",
      successMessageText: "Bedankt voor uw feedback!",
      '--inset': 'auto 100px 0 auto'
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0,// If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
